// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__20-gc","rootCenter":"LoadMoreObserver_rootCenter__19t9x","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1BoUg"};